export const REVIEW_BOOKING = 'review-booking';
const reviewBooking = ({ booking }) => ({ type: REVIEW_BOOKING, payload: { reviewedBooking: booking } });
export default reviewBooking;
